import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { UserId } from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type SetUserNameCommand = {
    readonly _id: string;
    readonly _type: "SET_USER_NAME_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly userId: UserId;
    readonly firstName?: string | undefined;
    readonly lastName?: string | undefined;
};

type FactoryParams = Except<SetUserNameCommand, "_id" | "_type" | "_createdAt">;
const setUserNameCommandFactory = (
    params: FactoryParams,
): SetUserNameCommand => {
    const command = {
        ...params,
        _id: generateId({ prefix: "set_user_name_command__" }),
        _type: "SET_USER_NAME_COMMAND" as const,
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const setUserNameCommandZodSchema: z.ZodSchema<SetUserNameCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_USER_NAME_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    userId: userIdZodSchema,
    firstName: z.string().min(1).optional(),
    lastName: z.string().min(1).optional(),
});

export { setUserNameCommandFactory, setUserNameCommandZodSchema };
export type {
    SetUserNameCommand,
    FactoryParams as SetUserNameCommandFactoryParams,
};
